import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/index';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private AuthService: AuthService
  ) {
  }

  ngOnInit() {
    this.AuthService.handleRedirection();
  }
}
